(function () {
    'use strict';

    angular
        .module('app')
        .controller('InternalStatsController', InternalStatsController);

        InternalStatsController.$inject = ['$http', '$rootScope', '$stateParams', '$state', '$filter', '$scope', 'dateParser', 'dialog'];

    function InternalStatsController($http, $rootScope, $stateParams, $state, $filter, $scope, dateParser, dialog) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.no_scroll = false;
        $rootScope.change_header = true;
        $rootScope.separate_page = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.close = close;
        vm.saveInternalConcertNote = saveInternalConcertNote;
        vm.getNumberOfConcertsInMonth = getNumberOfConcertsInMonth;
        vm.getNumberOfCancelledConcertsInMonth = getNumberOfCancelledConcertsInMonth;
        vm.setConcertFilter = setConcertFilter;
        vm.panes = ['concerts', 'stats']
        vm.pane = 'concerts';
        vm.concert_filter = 'current';
        vm.onAdminActionChange = onAdminActionChange;
        vm.refundPayment = refundPayment;
        vm.showTagEditor = showTagEditor;
        vm.hideTagEditor = hideTagEditor;
        vm.hasTag = hasTag;
        vm.createTag = createTag;
        vm.updateTag = updateTag;
        vm.addTagRelation = addTagRelation;
        vm.removeTagRelation = removeTagRelation;
        vm.addOrRemoveTag = addOrRemoveTag;

        function getNumberOfConcertsInMonth(concerts, month) {
            return concerts.filter(function(concert) {return concert.monthYear == month;}).length;
        }

        function getNumberOfCancelledConcertsInMonth(concerts, month) {
            return concerts.filter(function(concert) {return (concert.monthYear == month) && concert.concert_cancelled_at;}).length;
        }

        function getUser() { //Gets information about the currently logged-in user
            return $http.get('api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                    return response.data;
                });
        }

        function getTags() { //Get all tags
            return $http.get('api/tags/')
                .then(function (response) {
                    vm.tags = response.data;
                    return response.data;
                });
        }

        function hasTag(tagId) { // returns whether a concert has a tag
            var response = false;
            vm.selected_concert.concert_tags.forEach(tag => {
                if (tagId == tag.tag_id) {
                    response = true;
                    return;
                }
            });
            return response;
        }

        function close() {
            $rootScope.no_scroll = false;
            return $state.go('frontpage');
        }

        function init(){
            vm.message = false;
            vm.pane = $stateParams.pane;

            var deregister_toggle_message = $scope.$on('toggle_message', function () {
                vm.message = false;
            });

            $scope.$on('$destroy', function () {
                $rootScope.hide_header = false;
                deregister_toggle_message();
            });

            getUser().then(function(response) {
                if(!response.is_admin) {
                    $state.go('frontpage');
                } else {
                    getKPIs();
                    getTags();
                    getCurrentConcerts().then(function() { setConcertFilter('current'); });
                    getUpcomingConcerts();
                    getRecentConcerts();
                    getPastConcerts();
                }
            });
        }

        function getKPIs(){
            return $http.get('api/internal_stats/kpis/')
                .then(function(response){
                    vm.stats = response.data;
                });
        }

        function getCurrentConcerts(){
            return $http.get('api/internal_stats/current_concerts/')
                .then(function(response){
                    vm.current_concerts = response.data;
                });
        }

        function getUpcomingConcerts(){
            return $http.get('api/internal_stats/upcoming_concerts/')
                .then(function(response){
                    vm.upcoming_concerts = response.data;
                });
        }

        function getRecentConcerts(){
            return $http.get('api/internal_stats/recent_concerts/')
                .then(function(response){
                    vm.recent_concerts = response.data;
                });
        }

        function getPastConcerts(){
            return $http.get('api/internal_stats/past_concerts/')
                .then(function(response){
                    vm.past_concerts = response.data;
                });
        }

        function saveInternalConcertNote(concert){
            var data = {
                facebook_event: concert.facebook_event,
                notes: concert.notes
            }

            return $http.post('api/internal_concert_note/' + concert.concert_slug + '/', data)
                .then(function(response){

                });
        }

        function setConcertFilter(filter) {
            vm.concert_filter = filter;
            switch(filter) {
                case 'current':
                    vm.concerts_filtered = vm.current_concerts;
                break;
                case 'upcoming':
                    vm.concerts_filtered = vm.upcoming_concerts;
                break;
                case 'recently_added':
                    vm.concerts_filtered = vm.recent_concerts;
                break;
                case 'past':
                    vm.concerts_filtered = vm.past_concerts;
                break;
            }
        }

        function onAdminActionChange(concert) {
            if(concert.admin_action == "cancel"){
                cancelConcert(concert);
            }
        }

        function cancelConcert(concert) {
            dialog.prompt('cancel-concert-prompt', function (response) {
                if (response.confirm) {
                    $http.patch('api/cancel_concert/' + concert.concert_slug + '/')
                        .then(function(response) {
                            dialog.info('concert-cancelled-info');
                        }).catch(function(response) {
                            alert('ERROR: ' + JSON.stringify(response));
                        });
                }
                concert.admin_action = "";
            });
        }

        function refundPayment(payment) {
            dialog.prompt('refund-tickets-prompt', function (response) {
                if (response.confirm) {
                    if(payment.checkout_id == null) {
                        $http.patch('api/cancel_ticket_payment/' + payment.ticket_stripe_charge_id + '/')
                            .then(dialog.info('tickets-refunded-info')).catch(function(response) {
                            alert('ERROR: ' + JSON.stringify(response));
                        });
                    } else {
                        $http.patch('api/cancel_ticket_checkout/' + payment.checkout_id + '/')
                            .then(dialog.info('tickets-refunded-info')).catch(function(response) {
                            alert('ERROR: ' + JSON.stringify(response));
                        });
                    }
                }
            });
        }

        function createTag() {
            var data = {
                tag_name: vm.new_tag_name
            };
            $http.post('api/tags/', data)
                .then(function (response) {
                    getTags();
                    vm.new_tag_name = "";
                })
        }

        function addTagRelation(tag_id, concert_id) {
            var data = {
                tag_id: tag_id,
                concert_id: concert_id
            };
            return $http.post('api/add_tag_relation/', data)
                .then(function (response) {
                    getTags();
                    vm.selected_concert.concert_tags.push(response.data);
                })
        }

        function removeTagRelation(tag_id, concert_id) {
            var data = {
                tag_id: tag_id,
                concert_id: concert_id
            };
            return $http.post('api/remove_tag_relation/', data)
                .then(function (response) {
                    getTags();
                    removeOldTagRelation(response.data.tag_relation_id);
                })
        }

        function removeOldTagRelation(tag_relation_id) {
            var updated_concert_tags = vm.selected_concert.concert_tags.filter(function(tag_relation) {
                return tag_relation.tag_relation_id != tag_relation_id;
            });
            vm.selected_concert.concert_tags = updated_concert_tags;
        }

        function updateTag(old_tag_name) {
            var data = {
                tag_name: old_tag_name,
                new_tag_name: vm.update_tag_name
            };
            $http.post('api/tags/update/', data)
                .then(function (response) {
                    getTags();
                    vm.selected_concert.concert_tags.forEach(tag => {
                        if (tagId == tag.tag_id) {
                            response = true;
                            return;
                        }
                    });
                })
        }

        function addOrRemoveTag(tag){
            if(hasTag(tag.tag_id) == true){
                removeTagRelation(tag.tag_id, vm.selected_concert.concert_id);
            } else {
                addTagRelation(tag.tag_id, vm.selected_concert.concert_id);
            }
        }

        function showTagEditor(concert){
            vm.selected_concert = concert;
            vm.show_tag_editor = true;
        }

        function getConcerts(){
            if(vm.concert_filter == 'upcoming'){
                getUpcomingConcerts();
            }
            if(vm.concert_filter == 'current'){
                getCurrentConcerts();
            }
        }

        function hideTagEditor(){
            vm.show_tag_editor = false;
            vm.update_tag_name = undefined;
            vm.tags.forEach(tag => {
                if (tag.edit == true) {
                    tag.edit = false;
                    return;
                }
            });
        }
    }
})();
